import { render } from "./Sandbox.vue?vue&type=template&id=1bc502ec&scoped=true"
import script from "./Sandbox.vue?vue&type=script&lang=ts"
export * from "./Sandbox.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1bc502ec"

export default script